(function(app) {

    app.provider("portalApi",
    [
        function() {
            this.$get = [
                "crmApiGateway", function(crmApiGateway) {
                    var service = {};

                    service.getToken = function () {
                        return crmApiGateway.get("/Portal/Token");
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line